import Index from '@/views/apps/inputOutputAdjust/Index.vue'
import Adjust from '@/views/apps/inputOutputAdjust/Adjust.vue'
import layouts from '@/layout'

export default {
	path: 'adjust',
	name: 'Documentos',
	auth: true,
	component: Index,
	redirect: { path: '/adjust', name: 'Ajustes' },
	icon: 'file',
	meta: {
		auth: true,
		nav: true,
		roles: ['admin', 'cashier']
	},
	children: [
		{
			path: '/adjust_input',
			name: 'Entrada',
			component: Adjust,
			meta: {
				// 1 = Entrada y 2 = Salida
				type: 1,
				typeDocument: 7,
				auth: true,
				nav: true,
        layout: layouts.navLeft,
        searchable: true,
				tags: ['Ajuste', 'Entrada'],
				roles: ['admin', 'cashier'],
        icon: 'bank-transfer-in'
			}
		},
		{
			path: '/adjust_output',
			name: 'Salida',
			component: Adjust,
			meta: {
				// 1 = Entrada y 2 = Salida
				type: 2,
				typeDocument: 8,
				auth: true,
				nav: true,
        layout: layouts.navLeft,
        searchable: true,
				tags: ['Ajuste', 'Salida'],
				roles: ['admin', 'cashier'],
				icon: 'bank-transfer-out'
			}
		},
		{
      path: '/adjust_output1',
			name: 'Traslado',
			component: Adjust,
			meta: {
        // 1 = Entrada y 2 = Salida
				type: 2,
				typeDocument: 3,
				auth: true,
				nav: true,
        layout: layouts.navLeft,
        searchable: true,
				tags: ['Traslado', 'Salida', 'Entrada'],
				roles: ['admin', 'cashier'],
        icon: 'bank-transfer'
			}
		},
	]
}
